import React from 'react';
import { withTranslation } from 'react-i18next';

class ProgramContentEntriesTableHeader extends React.Component {
  render() {
    const { showActions, t } = this.props;

    return (
      <thead>
        <tr>
          <th>{t('library.programContent.title')}</th>
          <th>{t('library.programContent.description')}</th>
          {showActions && <th>{t('library.programContent.actions')}</th>}
          <th></th>
        </tr>
      </thead>
    );
  }
}

export default withTranslation()(ProgramContentEntriesTableHeader);
